import React from "react";
import { Button, Icon } from "antd";
import { useHistory } from "react-router-dom";
import styles from "./index.module.scss";
import useDeviceType from "../../../../Utils/useDeviceType";

interface ChapterHeaderExtraProps {
    weekTimeId?: string;
}

export default function ChapterHeaderExtra({
    weekTimeId
}: ChapterHeaderExtraProps) {
    const { isPC } = useDeviceType();
    const history = useHistory();

    if (!weekTimeId) return null;

    return (
        <Button
            type="link"
            title="学习计划"
            onClick={() => history.goBack()}
            className={styles.root}>
            <Icon type="profile" style={{ fontSize: isPC ? 24 : 16 }} />
        </Button>
    );
}
